import { Injectable } from '@angular/core';
import {HttpBackend, HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class ExternalService {


  private http: HttpClient

  constructor(private router: Router, handler: HttpBackend) {
    this.http = new HttpClient(handler);
  }

  getIPAddress() {
    return this.http.get('https://api.ipify.org/?format=json');
  }

}
